import { CustomerPortalOptionsVoData } from "../..";
var CustomerPortalOptionsConverter = /** @class */ (function () {
    function CustomerPortalOptionsConverter() {
    }
    CustomerPortalOptionsConverter.convertCustomerPortalOptionsToVo = function (customerPortalOptions) {
        var customerPortalOptionsVoData = new CustomerPortalOptionsVoData(customerPortalOptions.id);
        customerPortalOptionsVoData.customerAccessPolicy = customerPortalOptions.customerAccessPolicy;
        customerPortalOptionsVoData.inheritParentPermissions = customerPortalOptions.inheritParentPermissions;
        customerPortalOptionsVoData.trackSubmittedFeedback = customerPortalOptions.trackSubmittedFeedback;
        customerPortalOptionsVoData.everybodyTrackSubmittedFeedback = customerPortalOptions.everybodyTrackSubmittedFeedback;
        customerPortalOptionsVoData.viewHomeFeedback = customerPortalOptions.viewHomeFeedback;
        customerPortalOptionsVoData.viewOwnFeedback = customerPortalOptions.viewOwnFeedback;
        customerPortalOptionsVoData.viewPreviouslySubmittedItems = customerPortalOptions.viewPreviouslySubmittedItems;
        customerPortalOptionsVoData.visibilityPermissions = customerPortalOptions.visibilityPermissions;
        customerPortalOptionsVoData.visibilityContainerPermissions = customerPortalOptions.visibilityContainerPermissions;
        customerPortalOptionsVoData.viewOwnUnpublishedItems = customerPortalOptions.viewOwnUnpublishedItems;
        customerPortalOptionsVoData.viewAllItems = customerPortalOptions.viewAllItems;
        customerPortalOptionsVoData.filterItemsByItemType = customerPortalOptions.filterItemsByItemType;
        customerPortalOptionsVoData.filterItemsByProject = customerPortalOptions.filterItemsByProject;
        customerPortalOptionsVoData.filterItemsByStatus = customerPortalOptions.filterItemsByStatus;
        customerPortalOptionsVoData.enableSorting = customerPortalOptions.enableSorting;
        customerPortalOptionsVoData.enableFollowing = customerPortalOptions.enableFollowing;
        customerPortalOptionsVoData.registrationPolicy = customerPortalOptions.registrationPolicy;
        customerPortalOptionsVoData.specifiedItemTypes = customerPortalOptions.specifiedItemTypes;
        return customerPortalOptionsVoData;
    };
    return CustomerPortalOptionsConverter;
}());
export { CustomerPortalOptionsConverter };
//# sourceMappingURL=customer-portal-options-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/customer-portal-options-converter.js
// module id = 844
// module chunks = 14